import { render, staticRenderFns } from "./assign_permission.vue?vue&type=template&id=35ea67fa&"
import script from "./assign_permission.vue?vue&type=script&lang=js&"
export * from "./assign_permission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports